import React, { ComponentType } from "react";
import { PillarTableBaseColumnProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import PillarTableHeaderOrderBy from "shared/components/pillar-table/header/PillarTableHeaderOrderBy";
import { getFixedColumnStyle } from "shared/components/pillar-table/helpers/addFixedStyleToColumn";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import { PillarTableSafeAny } from "shared/components/pillar-table/PillarTableSafeAny";

export const PillarTableHeaderDefaultHeaderComponent = <
  RowGeneric = PillarTableSafeAny,
  ExtraPropsGeneric = PillarTableSafeAny | undefined,
  InlineEditFormGeneric = PillarTableSafeAny | undefined,
>(
  props: PillarTableBaseColumnProps<
    RowGeneric,
    ExtraPropsGeneric,
    InlineEditFormGeneric
  >,
) => {
  return <div className="flex flex-row items-center">{props.heading}</div>;
};

const PillarTableHeaderCell = <
  RowGeneric = PillarTableSafeAny,
  ExtraPropsGeneric = PillarTableSafeAny | undefined,
  InlineEditFormGeneric = PillarTableSafeAny | undefined,
>({
  column,
  index,
}: {
  index: number;
  column: React.ReactElement<
    PillarTableSafeAny,
    string | React.JSXElementConstructor<PillarTableSafeAny>
  >;
}) => {
  const context = usePillarTableContext<
    RowGeneric,
    ExtraPropsGeneric,
    InlineEditFormGeneric
  >();
  const ColumnComponent = column.type as
    | null
    | ComponentType<Record<string, unknown>>
    | (ComponentType<Record<string, unknown>> & {
        HeaderComponent?: ComponentType<Record<string, unknown>>;
      });

  const typedColumnComponent = ColumnComponent as unknown as {
    HeaderComponent?: ComponentType<Record<string, unknown>>;
  };
  const HeaderComponent =
    typedColumnComponent.HeaderComponent ??
    PillarTableHeaderDefaultHeaderComponent;

  return (
    <th
      ref={(el: HTMLTableCellElement | null) => {
        if (context!.columnRefs?.current) {
          context!.columnRefs.current[index] = el;
        }
      }}
      className={`pillartable-table-header-cell-general ${
        column.props?.headingClassName ?? ""
      } ${column.props?.orderByKey ? "cursor-pointer" : ""}`}
      style={getFixedColumnStyle({
        column,
        index,
        fixedColumnWidths: context!.fixedColumnWidths,
        customStyles: null,
        isHeaderCell: true,
      })}
      onClick={() =>
        column.props?.orderByKey
          ? context!.toggleSorting(column.props?.orderByKey)
          : null
      }
    >
      <HeaderComponent {...column.props} />
      <PillarTableHeaderOrderBy {...column.props} />
    </th>
  );
};

export default PillarTableHeaderCell;
